import baseApi from "@/api/baseApi";
import { valueTypeObject } from "@/types/commentInterface";

const api = {
  async getComments(commentsType: valueTypeObject) {
    const response = await baseApi({
      method: "post",
      url: `/comment/comments`,
      data: commentsType,
      headers: {
        hideLoader: "true",
      },
    });

    return response.data;
  },
  async saveComment(comment: any) {
    const response = await baseApi({
      method: "post",
      url: `/comments/save`,
      data: comment,
      headers: {
        hideLoader: "true",
      },
    });

    return response.data;
  },
};

export default api;
